import common from './modules/common';
import lookup from './modules/lookup';
import tabs from './modules/tabs';
import bigIntroSearch from './modules/big-intro-search';

common();
lookup();
tabs();
bigIntroSearch();